









































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class AppDatePicker extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(String) readonly label!: string;
  @Prop({ type: String }) readonly placeholder!: string;
  @Prop({ type: String, default: '1900-01-01' }) readonly startDate!: string;
  @Prop({ type: String }) readonly endDate!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: [Number, String], default: 289 }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  model = '';

  show = false;

  rules = {
    required: (value: string) => !!value || '不能为空!'
  };

  top = 0;
  left = 0;

  mounted () {
    this.model = this.value
  }

  clearModel () {
    this.valueChangedHandler('')
  }

  @Emit('input')
  valueChangedHandler (val: string) {
    this.model = val
    this.show = false
    return val
  }

  @Emit()
  submit () {
    // do nothing
  }

  handlefocus () {
    const pickerIcon = this.$refs.pickerIcon as Vue & {
      getBoundingClientRect: () => any;
    }
    this.top = pickerIcon.getBoundingClientRect().y - 100
    this.left = pickerIcon.getBoundingClientRect().x - 266
    this.show = true
  }

  allowedDates (val: string) {
    const endDate = this.endDate
      ? this.endDate === 'max'
        ? this.$moment().add(100, 'y')
        : this.$moment(this.endDate)
      : this.$moment()
    const isBefore = this.$moment(val).isAfter(this.$moment(this.startDate))
    const isAfter = this.$moment(val).isBefore(endDate)
    return isBefore && isAfter
  }
}
